// icons
import UserIcon from '@mui/icons-material/Person'
import VpnKeyIcon from '@mui/icons-material/VpnKey'
import PositionIcon from '@mui/icons-material/Group'
import AccountIcon from '@mui/icons-material/Business'
import SecurityIcon from '@mui/icons-material/Security'
import NotesRounded from '@mui/icons-material/NotesRounded'
import { VerginaSunIcon } from 'components/UI/Icons'
// views
import {
  ObjectIcon,
  PowerBiIcon,
  PrivacyIcon,
  LocationsIcon,
  IntegrationIcon,
  BusinessUnitsIcon,
  SystemProcessesIcon,
  BusinessActivityIcon,
  BusinessProcessesIcon
} from './views'

export const settingsSidebarConfig = [
  {
    name: 'Account',
    icon: <AccountIcon color='inherit' />,
    getLink: ({ user }) => (user.isAdmin ? '/settings/accounts' : `/settings/accounts/${user.companyId}`),
    path: ['/settings/accounts']
  },
  {
    name: 'Users',
    icon: <UserIcon color='inherit' />,
    getLink: () => '/settings/users',
    path: ['/settings/users']
  },
  {
    name: 'Positions',
    icon: <PositionIcon color='inherit' />,
    getLink: () => '/settings/positions',
    path: ['/settings/positions']
  },
  {
    name: 'Business Units',
    icon: <BusinessUnitsIcon color='inherit' />,
    getLink: () => '/settings/business-units',
    path: ['/settings/business-units']
  },
  {
    name: 'Locations',
    icon: <LocationsIcon color='inherit' />,
    getLink: () => '/settings/locations',
    path: ['/settings/locations']
  },
  {
    name: 'Business Processes',
    icon: <BusinessProcessesIcon color='inherit' />,
    getLink: () => '/settings/business-processes',
    path: ['/settings/business-processes']
  },
  {
    name: 'Business Activities',
    icon: <BusinessActivityIcon color='inherit' />,
    getLink: () => '/settings/business-activities',
    path: ['/settings/business-activities']
  },
  {
    name: 'Security',
    icon: <SecurityIcon color='inherit' />,
    getLink: () => '/settings/security',
    path: ['/settings/security']
  },
  {
    name: 'Objects & Properties',
    icon: <ObjectIcon color='inherit' />,
    getLink: () => '/settings/objects',
    path: ['/settings/objects']
  },
  {
    name: 'System Processes',
    icon: <SystemProcessesIcon color='inherit' />,
    getLink: () => '/settings/system-processes',
    path: ['/settings/system-processes']
  },
  {
    name: 'Plan Types',
    icon: <NotesRounded color='inherit' />,
    getLink: () => '/settings/plan-types',
    path: ['/settings/plan-types']
  },
  {
    name: 'API',
    icon: <VpnKeyIcon color='inherit' />,
    getLink: () => '/settings/api',
    path: ['/settings/api']
  },
  {
    name: 'Power BI',
    icon: <PowerBiIcon color='inherit' />,
    getLink: () => '/settings/power-bi',
    path: ['/settings/power-bi']
  },
  {
    name: 'Integrations',
    icon: <IntegrationIcon />,
    getLink: () => '/settings/integrations',
    path: ['/settings/integrations']
  },
  {
    name: 'Data Privacy',
    icon: <PrivacyIcon />,
    getLink: () => '/settings/data-privacy',
    path: ['/settings/data-privacy']
  },
  {
    name: 'AI Usage',
    icon: <VerginaSunIcon />,
    getLink: () => '/settings/ai-usage',
    path: ['/settings/ai-usage']
  }
]
